import { useContext } from "react";
import config from "../../config";
import { useMutation } from "@tanstack/react-query";
import { AppContext } from "@/App.context";

const setBudget = (token) => {
  return async ({ body, service }) => {
    const setBudget = await fetch(
      `${config.apiHost}/v1/${service}/budget/create`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify(body),
      }
    );

    if (!setBudget.ok) {
      const errorResponse = await setBudget.json();
      throw new Error(errorResponse.message);
    }
    const data = await setBudget.json();

    return data;
  };
};

export const useCreateBudget = (deps = []) => {
  const appContext = useContext(AppContext);

  const mutate = useMutation({
    mutationKey: ["setBudget", ...deps],
    mutationFn: (body) => setBudget(appContext.idToken)(body),
  });
  return mutate;
};
